import type { VerifAIFlagFeedback } from '@/lib/apollo/query/getVerifAIFlags/query'

export const getSelectedFeedbackFromUser = (
  feedback: VerifAIFlagFeedback[],
  userId: string,
): VerifAIFlagFeedback | undefined =>
  [...feedback].reverse().find(f => f.userId === userId)
